import { IToolbarLopSelect } from "../../../model/common/IToolbarLopSelect";
import { IHoSoSinhVienViewModel } from "../../../model/response/category/IHoSoSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eToolbarLopActionsObj = {
    CHANGE_FILTER: {} as IToolbarLopSelect,
}

export type IToolbarLopActionTypes = IGenericActionType<typeof eToolbarLopActionsObj,"TOOBAR_LOP">;